const SDKComponent = {
  state: {
    iframe: '',
    SDKComponentMessage: '',
    floatBall: '',
    notice: '',
    sdkNotice: '',
    rechargeAges: '',
    slideBar: '',
    token: '',
    screen: '',
    kefu: '',
    islandscape: '',
    isShowIosGuide: false,
    isBallMove: false,
  },
  mutations: {
    SET_COMPONENT_MESSAGE: (state, SDKComponentName) => {
      state.SDKComponentMessage = SDKComponentName
    },
    SET_COMPONENT_FLOAT: (state, floatBall) => {
      state.floatBall = floatBall
    },
    SET_COMPONENT_NOTICE: (state, fuseNotice) => {
      state.notice = fuseNotice
    },
    SET_COMPONENT_SDKNOTICE: (state, sdkNotice) => {
      state.sdkNotice = sdkNotice
    },
    GET_RECHARGE_AGES: (state, rechargeAges) => {
      state.rechargeAges = rechargeAges
    },
    SET_COMPONENT_SLIDEBAR: (state, slideBar) => {
      state.slideBar = slideBar
    },
    SET_COMPONENT_IFRAME: (state, iframe) => {
      state.iframe = iframe
    },
    SET_COMPONENT_TOKEN: (state, token) => {
      state.token = token
    },
    SET_COMPONENT_SCREEN: (state, screen) => {
      state.screen = screen
    },
    SET_COMPONENT_KEFU: (state, kefu) => {
      state.kefu = kefu
    },
    SET_ISLANDSCAPE: (state, islandscape) => {
      state.islandscape = islandscape
    },
    UPDATE_IOS_GUIDE: (state, isShow) => {
      state.isShowIosGuide = isShow
    },
    UPDATE_BALL_STATUS: (state, isMove) => {
      state.isBallMove = isMove
    }
  },
  actions: {
    SET_SDK_COMPONENT_MESSAGE ({commit}, SDKComponentName) {
      commit('SET_COMPONENT_MESSAGE', SDKComponentName)
    },
    SET_SDK_COMPONENT_FLOATBALL ({commit}, floatBall) {
      commit('SET_COMPONENT_FLOAT', floatBall)
    },
    SET_SDK_COMPONENT_NOTICE ({commit}, Notice) {
      commit('SET_COMPONENT_NOTICE', Notice)
    },
    SET_SDK_COMPONENT_SDKNOTICE ({commit}, sdkNotice) {
      commit('SET_COMPONENT_SDKNOTICE', sdkNotice)
    },
    GET_SDK_RECHARGE_AGES ({commit}, rechargeAges) {
      commit('GET_RECHARGE_AGES', rechargeAges)
    },
    SET_SDK_COMPONENT_SLIDEBAR ({commit}, slideBar) {
      commit('SET_COMPONENT_SLIDEBAR', slideBar)
    },
    SET_SDK_COMPONENT_IFRAME: ({commit}, iframe) => {
      commit('SET_COMPONENT_IFRAME', iframe)
    },
    SET_SDK_COMPONENT_TOKEN: ({commit}, token) => {
      commit('SET_COMPONENT_TOKEN', token)
    },
    SET_SDK_COMPONENT_SCREEN: ({commit}, screen) => {
      commit('SET_COMPONENT_SCREEN', screen)
    },
    SET_SDK_COMPONENT_KEFU: ({commit}, kefu) => {
      commit('SET_COMPONENT_KEFU', kefu)
    },
    SET_SDK_ISLANDSCAPE: ({commit}, islandscape) => {
      commit('SET_ISLANDSCAPE', islandscape)
    }
  }
}
export default SDKComponent
